/**
 * Marker2D parser: the Node2D transform and modulate, and `gizmo_extents`, the
 * cross-gizmo arm length (Godot default 10).
 */
import { parseNode2D } from '../../base/node2d/parser';
import { floatOr } from '../../../parser/valueParsers';
export function parseMarker2D(heading, properties) {
    const base = parseNode2D(heading, properties);
    return {
        ...base,
        gizmo_extents: floatOr(properties.gizmo_extents, 10),
    };
}
//# sourceMappingURL=parser.js.map